import React, { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Space } from "antd";
import "./edit_table_goods_receive.css";
import { PoItemDataType } from "../../components/hoc_goods_receive";
import BrowserLocationCodeForGoodsReceive from "./browser_location_code_for_goods_receive";
import axios from "axios";

interface EditTableGoodsReceiveProps {
     selectedPoItem: PoItemDataType | null;
     onUpdateItem: (updatedItem: PoItemDataType) => void;
     onSelectLocationCode: (locationCode: string) => void;
     goodsReceiveNo: string | undefined;
     refDocumentNo: string | undefined;
     onCancel: () => void;
     warehouse?: string;
}

const EditTableGoodsReceive: React.FC<EditTableGoodsReceiveProps> = ({
     selectedPoItem,
     onUpdateItem,
     onSelectLocationCode,
     goodsReceiveNo,
     refDocumentNo,
     onCancel,
     warehouse
}) => {
     const transformStyle = { transform: "scale(0.80)", transformOrigin: "top left", width: "125%" };
     const [form] = Form.useForm();
     const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);

     useEffect(() => {
          if (selectedPoItem) {
               form.setFieldsValue({
                    item_code: selectedPoItem.item_code,
                    item_name: selectedPoItem.item_name,
                    location_code: selectedPoItem.location,
                    uom: selectedPoItem.uom,
                    uom_rate: selectedPoItem.uom_rate,
                    qty_reference: selectedPoItem.ref,
                    qty_do: selectedPoItem.do,
                    qty_received: selectedPoItem.receive,
                    qty_short: selectedPoItem.short,
                    qty_demage: selectedPoItem.dmg,
                    qty_over: selectedPoItem.over,
                    qty_wrong: selectedPoItem.wrong,
                    case: selectedPoItem.case,
                    do_no: selectedPoItem.do_no,
               });
          } else {
               form.resetFields();
          }
     }, [selectedPoItem, form]);

     const onFinish = (values: any) => {
          if (selectedPoItem) {
               const updatedItem: PoItemDataType = {
                    ...selectedPoItem,
                    item_code: values.item_code,
                    item_name: values.item_name,
                    location: values.location_code,
                    uom: values.uom,
                    uom_rate: values.uom_rate,
                    ref: values.qty_reference,
                    do: values.qty_do,
                    receive: values.qty_received,
                    short: values.qty_short,
                    dmg: values.qty_demage,
                    over: values.qty_over,
                    wrong: values.qty_wrong,
                    case: values.case,
                    do_no: values.do_no,
               };
               onUpdateItem(updatedItem);
          }
     };

     const showLocationModal = () => {
          setIsLocationModalOpen(true);
     };

     const handleLocationModalCancel = () => {
          setIsLocationModalOpen(false);
     };

     const handleSelectLocationFromModal = (locationCode: string) => {
          form.setFieldsValue({ location_code: locationCode });
          onSelectLocationCode(locationCode);
          handleLocationModalCancel();
     };

     return (
          <div id="ieml" style={transformStyle}>
               <div className="gjs-grid-row" id="i87g">
                    <div className="gjs-grid-column" id="i5cz">
                         <Form
                              layout="horizontal"
                              style={{ maxWidth: 500 }}
                              labelCol={{ style: { width: "150px", textAlign: "left" } }}
                              wrapperCol={{ style: { width: "290px" } }}
                              className="custom-info-purchase-request"
                              form={form}
                              onFinish={onFinish}>
                              <Form.Item label="Item Code" name="item_code" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" style={{}} readOnly />
                              </Form.Item>
                              <Form.Item label="Item Name" name="item_name" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" readOnly />
                              </Form.Item>
                              <Form.Item label="Location Code" style={{ marginBottom: "5px" }}>
                                   <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                        <Form.Item name="location_code" noStyle style={{ width: "85%" }}>
                                             <Input placeholder="" readOnly/>
                                        </Form.Item>
                                        <Button
                                             type="primary"
                                             id="browser_location_code_for_goods_receive"
                                             onClick={showLocationModal}
                                             icon={
                                                  <svg
                                                       xmlns="http://www.w3.org/2000/svg"
                                                       viewBox="0 0 24 24"
                                                       fill="currentColor"
                                                       style={{ width: "22px", height: "22px" }}>
                                                       <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                       <path
                                                            fillRule="evenodd"
                                                            d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                            clipRule="evenodd"
                                                       />
                                                       <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                                  </svg>
                                             }
                                        />
                                   </div>
                              </Form.Item>
                              <Form.Item label="UOM" name="uom" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" readOnly />
                              </Form.Item>
                              <Form.Item label="UOM Rate" name="uom_rate" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" readOnly />
                              </Form.Item>
                              <Form.Item label="Qty. Reference" name="qty_reference" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" readOnly />
                              </Form.Item>
                              <Form.Item
                                   label="Qty. DO"
                                   name="qty_do"
                                   style={{ marginBottom: "5px" }}
                              >
                                   <Input placeholder="" />
                              </Form.Item>
                              <Form.Item
                                   label="Qty. Received"
                                   name="qty_received"
                                   style={{ marginBottom: "5px" }}
                                   rules={[
                                        { required: true, message: "Please input received quantity!" },
                                        ({ getFieldValue }) => ({
                                             validator(_, value) {
                                                  const qtyReference = parseFloat(
                                                       getFieldValue("qty_reference") || "0",
                                                  );
                                                  const qtyReceived = parseFloat(value || "0");

                                                  if (isNaN(qtyReceived) || qtyReceived < 0) {
                                                       return Promise.reject(
                                                            new Error(
                                                                 "Qty Received must be a valid non-negative number.",
                                                            ),
                                                       );
                                                  }

                                                  if (qtyReceived > qtyReference) {
                                                       return Promise.reject(new Error("Qty yang dimasukan melebihi batas !"));
                                                  }

                                                  return Promise.resolve();
                                             },
                                        }),
                                   ]}>
                                   <Input placeholder="" />
                              </Form.Item>
                              <Form.Item
                                   label="Qty. Short"
                                   name="qty_short"
                                   style={{ marginBottom: "5px" }}
                                   rules={[
                                        ({ getFieldValue }) => ({
                                             validator(_, value) {
                                                  const qtyReference = parseFloat(
                                                       getFieldValue("qty_reference") || "0",
                                                  );
                                                  const qtyShort = parseFloat(value || "0");
                                                  if (qtyShort > qtyReference) {
                                                       return Promise.reject(
                                                            new Error(
                                                                 "Qty Short melebihi dari jumlah Qty Reference",
                                                            ),
                                                       );
                                                  }
                                                  return Promise.resolve();
                                             },
                                        }),
                                   ]}>
                                   <Input placeholder="" />
                              </Form.Item>
                              <Form.Item
                                   label="Qty. Damage"
                                   name="qty_demage"
                                   style={{ marginBottom: "5px" }}
                                   rules={[
                                        ({ getFieldValue }) => ({
                                             validator(_, value) {
                                                  const qtyReference = parseFloat(
                                                       getFieldValue("qty_reference") || "0",
                                                  );
                                                  const qtyDamage = parseFloat(value || "0");
                                                  if (qtyDamage > qtyReference) {
                                                       return Promise.reject(
                                                            new Error(
                                                                 "Qty Damage melebihi dari jumlah Qty Reference",
                                                            ),
                                                       );
                                                  }
                                                  return Promise.resolve();
                                             },
                                        }),
                                   ]}>
                                   <Input placeholder="" />
                              </Form.Item>
                              <Form.Item
                                   label="Qty. Over"
                                   name="qty_over"
                                   style={{ marginBottom: "5px" }}
                                   rules={[
                                        ({ getFieldValue }) => ({
                                             validator(_, value) {
                                                  const qtyReference = parseFloat(
                                                       getFieldValue("qty_reference") || "0",
                                                  );
                                                  const qtyOver = parseFloat(value || "0");
                                                  if (qtyOver > qtyReference) {
                                                       return Promise.reject(
                                                            new Error(
                                                                 "Qty Over melebihi dari jumlah Qty Reference",
                                                            ),
                                                       );
                                                  }
                                                  return Promise.resolve();
                                             },
                                        }),
                                   ]}>
                                   <Input placeholder="" />
                              </Form.Item>
                              <Form.Item
                                   label="Qty. Wrong"
                                   name="qty_wrong"
                                   style={{ marginBottom: "5px" }}
                                   rules={[
                                        ({ getFieldValue }) => ({
                                             validator(_, value) {
                                                  const qtyReference = parseFloat(
                                                       getFieldValue("qty_reference") || "0",
                                                  );
                                                  const qtyWrong = parseFloat(value || "0");
                                                  if (qtyWrong > qtyReference) {
                                                       return Promise.reject(
                                                            new Error(
                                                                 "Qty Wrong melebihi dari jumlah Qty Reference",
                                                            ),
                                                       );
                                                  }
                                                  return Promise.resolve();
                                             },
                                        }),
                                   ]}>
                                   <Input placeholder="" />
                              </Form.Item>
                              <Form.Item label="Case" name="case" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" />
                              </Form.Item>
                              <Form.Item label="DO No" name="do_no" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" />
                              </Form.Item>
                              <Space style={{ paddingTop: "20px" }}>
                                   <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{
                                             height: "40px",
                                             width: "120px",
                                             display: "flex",
                                             alignItems: "center",
                                             justifyContent: "center",
                                        }}
                                        icon={
                                             <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 24 24"
                                                  fill="currentColor"
                                                  style={{ width: "22px", height: "22px" }}>
                                                  <path
                                                       fillRule="evenodd"
                                                       d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z"
                                                       clipRule="evenodd"
                                                  />
                                             </svg>
                                        }>
                                        OK
                                   </Button>
                                   <Button
                                        type="primary"
                                        onClick={onCancel}
                                        style={{
                                             height: "40px",
                                             width: "120px",
                                             display: "flex",
                                             alignItems: "center",
                                             justifyContent: "center",
                                             backgroundColor: "red",
                                             color: "white",
                                             border: "none",
                                        }}>
                                        Cancel
                                   </Button>
                              </Space>
                         </Form>
                    </div>
               </div>
               <Modal
                    title="Browse Location Code"
                    open={isLocationModalOpen}
                    onCancel={handleLocationModalCancel}
                    footer={null}
                    width={800}>
                    {" "}
                    { }
                    <BrowserLocationCodeForGoodsReceive
                         onSelectLocation={handleSelectLocationFromModal}
                         warehouse={warehouse}
                    />
               </Modal>
          </div>
     );
};

export default EditTableGoodsReceive;
